<template lang="html">
  <div :class="css+' box-product-sample-s1'">
    <div class="box-link">
      <router-link class="fake-link" :to="'/producto/'+$root._converToURL(product.name, product.id)"></router-link>

      <!-- <span class="bubble" v-if="product.newnew == 1">Nuevo</span>
      <span class="bubble" v-if="product.indiscount != null" style="background-color: #cd2027;margin-left: 65%;">{{product.indiscount}}</span>
      <span class="bubble" v-if="product.live_stock == 1" style="bottom: 5px;top: unset;background-color: #cd519c;">Stock en vivo</span> -->

      <div class="box-image">
        <img class="placed-backg" src="public/images/shared/empty.png" v-bind:style="{ backgroundImage: 'url('+product.imageUrl+')' }">
      </div>

      <div class="box-bubbles">
        <span class="bubble" v-for="(tag,indx) in product.labels" :key="indx" :style="'background-color:'+tag.color_code+';top:'+tag.toppx">{{ tag.name }}</span>
      </div>

      <div class="box-descr">
        <h6 class="name">{{ product.name }}</h6>

        <div class="descr" v-html="product.description"> </div>

        <h6 class="price">
          <span>$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.first_price) }}</span>
          <span v-if="product.last_price"> - $ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.last_price) }}</span>
        </h6>
      </div>
      <a class="btn-cart" @click="openModal(product.id)"><i class="fal fa-shopping-cart"></i></a>
    </div>

    <!-- Modal de detalle de producto -->
    <b-modal ref="modal-product" modal-class="modal-product-detail" hide-footer title="" centered size="lg">
      <div class="pb-0" id="description-page">
        <section class="description-section">
          <div class="col-12 col-single-image">
            <img :src="modelimageUrl" v-if="form.modelo != null">
            <img :src="product.imageUrl" v-else>
          </div>

          <b-form class="col-description" @submit="addCart">
            <h1 class="text-center name" v-if="form.modelo != null">{{ product.name }}</h1>
            <h1 class="text-center name" v-else>{{ form.models_name }}</h1>
            <!-- <h6 class="text-center sku"><strong>SKU:</strong> 09</h6> -->

            <h4 class="mt-3 text-center price" v-if="form.modelo != null">
              <span v-if="price_orig != null" style="text-decoration:line-through;">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(price_orig) }} </span>
              <span>$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(price) }} </span><br />

            </h4>
            <h4 class="mt-3 text-center price" v-else>
              <span>$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.first_price) }}</span>
              <span v-if="product.last_price"> - $ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.last_price) }}</span>
            </h4>
            <!-- <h4 class="text-center model">1gr 1.00 Gramos</h4> -->

            <h6 class="mt-4 text-center subtitle">Presentaciones</h6>
            <b-collapse :visible="true" class="mt-1">
              <div class="mt-2 table-responsive">
                <table class="table table-sm table-pres" id="tablemodels">
                  <thead>
                    <tr>
                      <th class="c-input" style="width: 10%;"></th>
                      <th>Nombre</th>
                      <th style="min-width: 105px;">Precio</th>
                      <th>Existencia</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(model,indx) in product.models" :key="indx" >
                      <td class="c-input">
                        <div  style="padding-top: 8px; padding-bottom: 8px;">
                          <input style="position: relative;transform: scale(1.5);" type="radio" :id="'model'+indx" :name="model.id" :value="model.id" v-model="form.models_id" @click="changeModelid(indx,model.id)">

                        </div>
                      </td>
                      <td>{{model.name}}</td>
                      <td>
                        $ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(model.price) }}
                      </td>
                      <td class="text-center">{{model.stock}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-collapse>

            <hr />
            <div class="text-center">
              <h6 class="mt-2 subtitle" v-if="stock > 0">Stock disponible: <span class="txt-red">{{stock}}</span> </h6>
              <h6 class="mt-2 subtitle" v-else>Sin stock</h6>
            </div>

            <div class="justify-content-center col-quantity2 mt-2">
              <a class="form-control btn-q" @click="changeCantidad('-')">
                <i class="fas fa-minus"></i>
              </a>
              <b-form-input class="input-q" type="number" min="0" v-model="form.quantity" @keypress="isNumber($event)" @paste="noPaste" />
              <a class="form-control btn-q" @click="changeCantidad('+')">
                <i class="fas fa-plus"></i>
              </a>
            </div>

            <div class="d-block text-center mt-4" v-if="added">
                <p>Producto agregado al carrito</p>
            </div>
            <div class="d-block text-center mt-4" v-if="checkmodel">
                <p>Debes de seleccionar una presentacion</p>
            </div>
            <div class="d-block text-center mt-4">
              <b-button type="submit" class="btn-style-1 bg-green"> Agregar al carrito</b-button>
            </div>

          </b-form>
        </section>
      </div>

      <sweet-modal blocking hide-close-button ref="modalloading">
        <div class="fa-3x" v-if="modal.icon== ''"><i class="fas fa-spinner fa-pulse"></i></div><br/>
        <div>Cargando ...</div>
      </sweet-modal>

    </b-modal>
    <!--  -->
  </div>
</template>

<script>
export default {
  props: ['css', 'product'],

  data() {
    return {
      showModels:false,
      stock: 100,

      form: {
        modelo: null,
        quantity: 1,
        color: null,
        models:[],
        models_id:null,
        models_name:null,
      },
      modelimageUrl:null,
      added:false,
      checkmodel:false,
      modal:{
        msg:'',
        icon:'',
        block:false,
        cart:false,
      },
    }
  },

  methods: {
    noPaste(evt){
      event.preventDefault();
    },

    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    changeCantidad($type){
      this.form.quantity = parseInt(this.form.quantity);
      if ($type == '-') {
        this.form.quantity = (this.form.quantity > 1) ? --this.form.quantity : 1;
      }
      else{
        this.form.quantity = (this.form.quantity < 100) ? ++this.form.quantity : 100;
      }
    },

    openModal() {
      this.$refs['modal-product'].show();
    },

    changeModelid(indx,models_id){

        this.price = this.product.models[indx]['price'];
        this.price_orig = this.product.models[indx]['price_orig'];

        this.stock = this.product.models[indx]['stock'];
        this.form.models_id = models_id;
        this.form.models_name = this.product.models[indx]['name'];

        if(this.product.models[indx]['imageUrl']){
            this.modelimageUrl = this.product.models[indx]['imageUrl'];
        }
        else{
            this.modelimageUrl = this.product.imageUrl;
        }

    },

    addCart(evt){
      this.added = false;
      this.checkmodel = false;
      evt.preventDefault();
      if(this.form.models_id == null){
       this.checkmodel = true;

        return;
      }

      var cart = [];
      var encontrado = false;
      if(localStorage.cart){
          cart = JSON.parse(localStorage.getItem('cart'));

          for(var i = 0; i < cart.length ; i++)
          {
              if(cart[i].id == this.product.id && cart[i].models_id == this.form.models_id)
              {
                  var suma = parseInt(cart[i].quantity) + parseInt(this.form.quantity);
                  cart[i].quantity = suma <= this.stock ? suma : this.stock;
                  encontrado = true;
                  break;
              }
          }

          if(!encontrado)
          {
              cart.push({ id:this.product.id, quantity:this.form.quantity, models_id: this.form.models_id });
          }
      }
      else
      {
          cart.push({ id:this.product.id, quantity:this.form.quantity, models_id: this.form.models_id });
      }
      if(this.product.id == 41){

        localStorage.setItem("comatografia",JSON.stringify(this.formcomatografia));
      }

      localStorage.setItem("cart",JSON.stringify(cart));
      this.$root.cartCount = cart.length;
      this.added = true;
    },
  }
}
</script>
